import { toast } from "sonner";
import { Share2, MessageCircle, Facebook, Send, Twitter, Link2 } from "lucide-react";

export const ShareSection = ({ content }) => {
  const pageUrl = typeof window !== "undefined" ? window.location.origin : "";
  const text = `${content.title} di ${content.author}: 20 attività creative per aiutare i bambini (6-11 anni) a riconoscere ed esprimere le emozioni. Sfoglia l'estratto gratuito e scarica la scheda omaggio qui:`;
  const encodedText = encodeURIComponent(text);
  const encodedUrl = encodeURIComponent(pageUrl);

  const channels = [
    {
      name: "WhatsApp",
      icon: MessageCircle,
      href: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
      testid: "share-whatsapp-button",
      classes: "bg-[#25D366] text-white hover:bg-[#1eb856]",
    },
    {
      name: "Facebook",
      icon: Facebook,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`,
      testid: "share-facebook-button",
      classes: "bg-[#1877F2] text-white hover:bg-[#0f66d8]",
    },
    {
      name: "Telegram",
      icon: Send,
      href: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
      testid: "share-telegram-button",
      classes: "bg-[#229ED9] text-white hover:bg-[#1b8ac0]",
    },
    {
      name: "X",
      icon: Twitter,
      href: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
      testid: "share-x-button",
      classes: "bg-stone-900 text-white hover:bg-stone-700",
    },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(`${text} ${pageUrl}`);
      toast.success("Link copiato! Incollalo dove vuoi: gruppi, chat, bacheche.");
    } catch {
      toast.error("Non riesco a copiare: copia l'indirizzo dalla barra del browser.");
    }
  };

  return (
    <section className="bg-gradient-to-b from-white to-warm py-16 sm:py-20" data-testid="share-section">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-terracotta-light px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-terracotta-dark">
          <Share2 className="h-3.5 w-3.5" /> Passaparola
        </span>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-olive sm:text-3xl lg:text-4xl" data-testid="share-title">
          Ti piace l'idea? Fai conoscere il quaderno
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-base text-stone-600 sm:text-lg">
          Con un click condividi questa pagina sui tuoi social: chi la apre trova l'estratto gratuito e il pulsante per acquistare il libro su Amazon.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          {channels.map((c) => (
            <a
              key={c.name}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={c.testid}
              className={`inline-flex items-center gap-2 rounded-full px-5 py-3 font-display text-sm font-semibold shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg ${c.classes}`}
            >
              <c.icon className="h-4 w-4" /> {c.name}
            </a>
          ))}
          <button
            type="button"
            onClick={copyLink}
            data-testid="share-copy-link-button"
            className="inline-flex items-center gap-2 rounded-full border-2 border-olive bg-white px-5 py-3 font-display text-sm font-semibold text-olive shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:bg-olive hover:text-white hover:shadow-lg"
          >
            <Link2 className="h-4 w-4" /> Copia link
          </button>
        </div>
      </div>
    </section>
  );
};
